module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 20
// module chunks = 1 2 3 4 5 6 7